module.exports = __webpack_public_path__ + "img/recenter.b1704734.png";